module.exports = __webpack_public_path__ + "ncaret_left_icon.svg";